import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response, ResponseContentType } from '@angular/http';
import * as crypto from 'crypto-js';
import * as moment from 'moment';;
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { catchError,map } from 'rxjs/operators';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { Member } from '../../shared/interface/member.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { ProductSource } from '../common/constants';
import { MemberLevel, OrderSources, OrderTypeValues } from '../common/enumerations';
import { MemberOrderType } from '../enums/member-order-type.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { PurchaseFlows } from '../enums/order-source-type';
import { OrderSourceValue } from '../enums/order-source.enum';
import { MoneyOrderRequest } from '../interface/money-order-request';
import { OrderRulesRequest } from '../interface/order-rules-request.interface';
import { PaymentDroolsRequest } from '../interface/payment-drools-request.interface';
import { PaymentDroolsResponse } from '../interface/payment-drools-response.interface';
import { PriceTierResponse } from '../interface/price-tier-response';
import { PudoLocationRequest } from '../interface/pudo-location-request.interface';
import { PudoLocation } from '../interface/pudo-location.interface';
import { ShippingOptionsRequest } from '../interface/shipping-options-request';
import { ShippingOptionsResponse } from '../interface/shipping-options-response';
import { StorePaymentMethod } from '../interface/store-payment-method.interface';
import { environment } from './../../../environments/environment';


@Injectable()
export class OrderService {



  headers: Headers;
  options: RequestOptions;
  constructor(private _http: Http, private _cacheService: CacheService, private _commonService: CommonService) {
    this.headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'q=0.8;application/json;q=0.9'
    });
    this.options = new RequestOptions({ headers: this.headers });
  }

  private handleErrorObservable(error: Response | any) {
    return Observable.throw(error);
  }

  getMemberInfo(memberInfo: string, type: any) {
    let getMemberInfo = '';
    if (type == 'fboId') {
      getMemberInfo = ApiUrlConstants.accountApiUrl + "member-details?distributorId=" + memberInfo;
    }
    else if (type == 'email') {
      getMemberInfo = ApiUrlConstants.accountApiUrl + "member-details?email=" + encodeURIComponent(memberInfo);
    }

    return this._http
      .get(getMemberInfo)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  getMemberAddressByMemberId(memberId: any, countryId: any) {
    let getMemberAddresses = ''
    if (countryId) {
      getMemberAddresses = ApiUrlConstants.accountApiUrl + "members/" + memberId + "/addresses?countryId=" + countryId + '&addressTypeId=40';
    } else {
      getMemberAddresses = ApiUrlConstants.accountApiUrl + "members/" + memberId + "/addresses?addressTypeId=40";
    }

    return this._http
      .get(decodeURIComponent(encodeURIComponent(getMemberAddresses)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);

  }

  /**
* save verifiedAddress
* @param  {any} verifiedAddress
* @returns Observable
*/
  saveVerifiedAddress(verifiedAddress: any): Observable<any> {
    return this._http
      .post(ApiUrlConstants.manageAccountApiGwUrl + 'members/' + verifiedAddress.memberId + '/addresses', verifiedAddress)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * get is back order date is allowed
   * @param  {any} offset
   * @returns Observable
   */
  isBackDateOrderAllowed(offset: any, countryCode: any): Observable<any> {
    return this._http
      .get(ApiUrlConstants.orderApiUrl + '/v1/back-order-allowed/' + offset + '?countryCode=' + countryCode)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getStoreInfo(countryCode: any) {

        let storeUrl = ApiUrlConstants.configurationApiUrl + "store-countries/" + countryCode;
        return this._http
            .get(storeUrl)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }
     /**
     * @description it will retrive all payemnt mehtods
     * what we have configured for the store
     * @date 2018-07-26
     * @param {number} storeId
     * @param {string} countryCode
     * @returns {Observable<any>}
     * @memberof PaymentService
     */
    getPaymentMethodsByStore(storeId: number, countryCode: string,countryLanguageCode: string,
      memberTypeId: number, wholesaleQualified: boolean,fpc5PercentEnabled? : boolean, isFPCEnrollment?: boolean,
      isServiceOrder?: boolean, memberId?: number, homeCountry?: string)
        : Observable<StorePaymentMethod[]> {
          const languageCode = countryLanguageCode? countryLanguageCode : this._cacheService.get(CacheKey.language);
          const headers = this.getPaymentHeaders();
        const purchaseFlowType = this._commonService.getPurchaseFlowType(memberTypeId, wholesaleQualified, fpc5PercentEnabled,
            isFPCEnrollment);
        if(isServiceOrder) {
            return this._http
            .get(ApiUrlConstants.paymentApiUrl
                + 'stores/' + 'service-order/' + storeId + '/service-payment-methods', { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
        } else {
          let paymentUrl = ApiUrlConstants.paymentApiUrl
            + 'stores/' + storeId + '/country-code/' + countryCode + '/order-type/'
            + purchaseFlowType + '/order-source/' + OrderSourceValue.CUSTOMER + '/payment-methods';
          let hasParams = false;
          if (memberId) {
            paymentUrl += '?memberId=' + memberId;
            hasParams = true;
          }
          
          if (homeCountry) {
            paymentUrl += (hasParams ? '&' : '?') + 'homeCountry=' + homeCountry;
          }
          return this._http
            .get(paymentUrl, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
        }
    }

  getPaymentDroosResponse(paymentdroolsRequest: PaymentDroolsRequest):Observable<PaymentDroolsResponse[]>{
    const headers = this.getPaymentHeaders();
    return this._http
    .post(ApiUrlConstants.paymentApiUrl + 'payments/payment-rules',
    JSON.stringify(paymentdroolsRequest), { headers: headers })
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);


}



    getPosPaymentMethods(storeId:number,locationID:number,orderTypeID:number){
      const headers = this.getPaymentHeaders();
      return this._http
            .get(ApiUrlConstants.paymentApiUrl + storeId +'/pos-payment-method?locationID='+locationID + '&orderTypeID=' +orderTypeID , { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }
     /**
     * @description this is used to get
     * payment headers
     * @date 2018-07-26
     * @returns {Headers}
     * @memberof PaymentService
     */
    getPaymentHeaders(): Headers {
        const headers = new Headers();
        const authHeader = 'PAY ' + environment.paymentApiKey + ':' + this.getHashedValue();
        headers.append('authorization', authHeader);
        return headers;
    }
     /**
     * @description this method is used to
     * get payment crypto hashed value
     * @date 2018-07-26
     * @returns {string}
     * @memberof PaymentService
     */
    getHashedValue(): string {
        const shavalue = crypto.HmacSHA1(environment.paymentSecurityKey, environment.paymentServiceKey);
        return crypto.enc.Base64.stringify(shavalue);
    }

    /**
      * @param  {any} details
      * @returns Observable
      */
    getShipmentService(shipMethodRequest: ShippingOptionsRequest): Observable<ShippingOptionsResponse> {
      return this._http
          .post(ApiUrlConstants.shippingApiUrl + 'shipping-options', shipMethodRequest)
          .map((res: Response) => res.json())
          .catch(this.handleErrorObservable);
  }

    /**
     * @date 24-06-2021
     * @param pudoLocationRequest this method will return pudo locations
     * @returns
     */

     getPudoLocations(pudoLocationRequest: PudoLocationRequest): Observable<PudoLocation> {
      const url = ApiUrlConstants.shippingApiUrl + '/' + 'pudo-locations';
       return this._http.post(url, pudoLocationRequest)
         .map((res: Response) => res.json())
         .catch(this.handleErrorObservable);

  }


  /**
   * create order
   * @param  {Order} paymentRequest
   * @returns Observable
   */
  createOrder(orderRequest: any): Observable<any> {
    return this._http
      .post(ApiUrlConstants.orderApiUrl + '/V1/orders', JSON.stringify(orderRequest))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
  * create order
  * @param  {Order} paymentRequest
  * @returns Observable
  */
  createNewOrder(orderRequest: any, url: string): Observable<any> {
    return this._http
      .post(url, JSON.stringify(orderRequest))
      .map((res: Response) => res)
      .catch(this.handleErrorObservable);
  }

  /**
   * get order details by order id
   * @param  {any} orderId
   * @returns Observable
   */
  getOrderDetailsById(webOrderId: any): Observable<any> {
    return this._http
      .get(ApiUrlConstants.orderApiUrl + '/V1/orders/' + webOrderId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * create order
   * @param  {Order} paymentRequest
   * @returns Observable
   */
  calculateOrderTax(taxRequest: any): Observable<any> {
    return this._http
      .post(ApiUrlConstants.taxApiUrl + '/taxservice/V1/api/calculate-tax', JSON.stringify(taxRequest))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
   * get titan orders
   * @param  member Id
   */
  //getRecentOrders(memberId: number) {
  // const url = ApiUrlConstants.orderApiUrl + '/V1/member-orders' + memberId;
  // return this._http
  //     .get(url)
  //    .map((res: Response) => res.json())
  //    .catch(this.handleErrorObservable);
  //}


  /**
 * Get order details for specific fboId
 * @param fboProfileId
 * @param pageNumber
 * @param pageSize
 * @param sort
 * @param sortColumn
 */
  getRecentOrders(fboProfileId: string, pageNumber?: number, pageSize?: number, sort?: String, sortColumn?: string[], fromDate?: string, toDate?: string, isOrderHistory?: boolean, orderSearchByorderNumber?: String,isCompleteOrderSearch?:Boolean) {
    let _url = ApiUrlConstants.orderApiUrl;
    if(orderSearchByorderNumber && isCompleteOrderSearch){
      _url = _url + "/V1/member-orders?pageSize=" + pageSize + "&sort=" + sort + "&elements=" + sortColumn  + "&distrubutorId=" + fboProfileId + "&isMemberLookUp=" + true + "&includeShipTrackUrl=" + true
      + "&searchTerm=" + orderSearchByorderNumber +"  &isCompleteOrderSearch="+ isCompleteOrderSearch;
    }
     else if (fromDate && toDate) {
      _url = _url + "/V1/member-orders?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&sort=" + sort + "&elements=" + sortColumn + "&orderFromDate=" + fromDate + "&orderToDate=" + toDate + "&distrubutorId=" + fboProfileId + "&isMemberLookUp=" + true + "&includeShipTrackUrl=" + false;
    }
    else if (fromDate) {
      _url = _url + "/V1/member-orders?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&sort=" + sort + "&elements=" + sortColumn + "&orderFromDate=" + fromDate + "&distrubutorId=" + fboProfileId + "&isMemberLookUp=" + true + "&includeShipTrackUrl=" + false;
    }
    else {
      _url = _url + "/V1/member-orders?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&sort=" + sort + "&elements=" + sortColumn + "&distrubutorId=" + fboProfileId + "&isMemberLookUp=" + true + "&includeShipTrackUrl=" + false;
    }
    if (isOrderHistory) {
      _url = _url + "&excludeStatusIds=15";
    }
     _url = _url + "&includeAssociateOrders=true";
    return this._http.get(_url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  };
  /*
 * get titan order information
 * @param  member Id
 */
  getRecentOrderInformation(webOrderID: string, countryCode?: string) {
    let url = ApiUrlConstants.orderApiUrl + '/V1/orders/' + webOrderID;
    if(countryCode){
      url = url + '?countryCode=' + countryCode;
    }
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
 * get order statuses
 *
 */
  getOrderStatuses() {
    const url = ApiUrlConstants.orderApiUrl + '/V1/order-statuses';
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
   * get addressInformation
   *
   */
  getBillingInfo(addressId: number) {
    const url = ApiUrlConstants.accountApiUrl + 'members/addresses/' + addressId;
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
* Get order details for specific WebOrderId
* @param WebOrderId
* @param pageNumber
* @param pageSize
* @param sort
* @param sortColumn
*/
  getOrderByWebOrderId(webOrderId: string, pageNumber?: number, pageSize?: number, sort?: String, sortColumn?: string[], fromDate?: string, toDate?: string, searchvalue?: string,selectedCountry?:string,alternativeLanguageSearch?:boolean) {
    let _url = ApiUrlConstants.orderApiUrl;

    _url = _url + "/V1/member-orders?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&sort=" + sort + "&isMemberLookUp=" + true;
    if (webOrderId) {
      _url = _url + "&webOrderId=" + webOrderId;
    }
    if (searchvalue) {
      _url = _url + "&searchTerm=" + searchvalue;
    }
    if(selectedCountry){
      _url = _url + "&countryCode=" + selectedCountry;
    }
    if(alternativeLanguageSearch)
      _url= _url+ "&alternativeLanguageSearch="+alternativeLanguageSearch;
    return this._http.get(_url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  };
  /**
   * To get recent products
   * @param  {number} storeId
   * @returns Observable
   */
  getProductsByIds(browsedProducts: number[], languageCode: string, storeId: number,
     memberTitleId: number, purchaseFlowType: string, isoCountryCode: string, wholesaleQualified: boolean, optin?: boolean,
      taxInclusive?: boolean, isReturnStatus?: boolean) {
    return (
      this._http
        .get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.productApiUrl + '/v1/stores/products/recentlyviewed?storeId=' + storeId +
          '&productIds=' + browsedProducts.join(',') + '&languageCode=' + languageCode +
          '&memberTitleId=' + memberTitleId + '&purchaseFlowType=' + purchaseFlowType + '&countryCode=' +
          isoCountryCode +  '&pageSize=100&pageNumber=1'+'&wholesaleQualified=' + wholesaleQualified + '&optin=' + optin +'&taxInclusive=' + taxInclusive + '&source=' + ProductSource.CSP+ '&searchType=FULL')))
        .map((res: Response) => {
          if (isReturnStatus && res.status === 204) {
            return res;
          } else {
            return res.json();
          }
        })
        .catch(this.handleErrorObservable)
    );
  }

  /**
   * @description get pricetier by member id
   * @date 2019-10-16
   * @param {number} memberTitleId
   * @returns {Observable<string>}
   * @memberof OrderService
   */
  getPriceTierByMemberId(storeId: number,memberTitleId: number, wholesaleQualified: boolean, optin: boolean, taxInclusive: boolean): Observable<PriceTierResponse> {
    const url = ApiUrlConstants.productApiUrl + '/v1/stores/'+ storeId +'/member-titles/' + memberTitleId
     + '/price-tier-details?wholesaleQualified=' + wholesaleQualified + '&optin=' + optin + '&taxInclusive=' + taxInclusive;
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
  * create order
  * @param  {Order} paymentRequest
  * @returns Observable
  */
  updateOrder(orderRequest: any, requestUrl: string): Observable<any> {
    return this._http
      .put(requestUrl, JSON.stringify(orderRequest))
      .map((res: Response) => res)
      .catch(this.handleErrorObservable);
  }

  /**
   * @description money order request
   * @date 2019-05-04
   * @param {string} webOrderID
   * @param {MoneyOrderRequest} moneyOrderRequest
   * @returns
   * @memberof OrderService
   */
  processMoneyOrder(webOrderID: string, moneyOrderRequest: MoneyOrderRequest) {
    const headers = this.getPaymentHeaders();
    const url = ApiUrlConstants.paymentApiUrl + 'payments/process-payment-details/' + webOrderID.toUpperCase();
    return this._http.patch(url, moneyOrderRequest, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /*
   * get shipping Method based on ShipmentMethodId
   *
   */
  getShippingMethod(storeId: number, shipmentMethod: number) {
    const url = ApiUrlConstants.shippingApiUrl + 'stores/' + storeId + '/shipping-methods/' + shipmentMethod;
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
   * get titan order information
   * @param  member Id
   */
  getPickupAddressInformation(shipMethodId: number, storeId: number) {
    // https://apigw-titanqa1.nextsphere.com/api/shipping/V1/stores/1/distribution-centers/128
    const url = ApiUrlConstants.shippingApiUrl + 'stores/' + storeId + '/distribution-centers/' + shipMethodId;
    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
   *
   * @param weborderId
   * @param notes
   */
  cancelOrder(weborderId: string, isCancelAlone: boolean): Observable<any> {
    let url = ApiUrlConstants.orderApiUrl + "/V1/orders/" + weborderId + "/cancel?isCancelAlone=" + isCancelAlone;
    return this._http
      .patch(url, {})
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  /**
 * To get order Notes
 * @param  {string} webOrderId
 * @returns Observable
 */
  getOrderNotes(webOrderId: string) {
    return (
      this._http
        .get(ApiUrlConstants.orderApiUrl + '/V1/orders/' + webOrderId + '/orderNotes')
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );
  }

  /**
   * To create order Notes
   * @param  {string} webOrderId
   * @param  {string} note
   * @returns Observable
   */
  createOrderNote(webOrderId: string, note: string, userId?: any, orderStatusChangeReasonId? :number) {
    let payload: any = {
      note: note,
      displayToCustomer: true,
      createdBy: userId
    }
    if(orderStatusChangeReasonId) {
      payload.orderStatusChangeReasonId = orderStatusChangeReasonId;
    }
    return (
      this._http
        .post(ApiUrlConstants.orderApiUrl + '/V1/orders/' + webOrderId + '/orderNotes', payload)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );
  }


  /**
* To get order Logs
* @param  {string} webOrderId
* @returns Observable
*/
  getOrderLogs(webOrderId: string) {
    return (
      this._http
        .get(ApiUrlConstants.orderApiUrl + '/V1/orders/' + webOrderId + '/logs')
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );
  }


  /**
* To get order Logs
* @param  {string} getDeliveryOptions
* @returns Observable
*/
  getDeliveryOptions(countryCode: string, getDeliveryOptionsRequest: any) {
    return (
      this._http
        .post(ApiUrlConstants.shippingApiUrl + countryCode + '/delivery-options', getDeliveryOptionsRequest)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );
  }

  /**
   * @description to get POS Order handling and fee charges
   * @date 2020-10-29
   * @param {ShippingOptionsRequest} shipMethodRequest
   * @param {number} pickUpCenterId
   * @returns {Observable<ShippingOptionsResponse>}
   * @memberof OrderService
   */
  getPOSHandlingFeeCharges(shipMethodRequest: ShippingOptionsRequest, pickUpCenterId: number): Observable<ShippingOptionsResponse>  {
    return this._http
      .post(ApiUrlConstants.shippingApiUrl + 'pick-up-center/'+ pickUpCenterId +'/charges',shipMethodRequest)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * create order logs
   * @param orderLogRequest
   */
  createOrderLog(orderLogRequest: any) {
    return (
      this._http
        .post(decodeURIComponent(encodeURIComponent(ApiUrlConstants.orderApiUrl + '/V1/orders/' + orderLogRequest.webOrderId + '/order-logs')), orderLogRequest)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );

  }


  /**
* To get order tracking Url
* @param  {string} WebOrderId
* @returns Observable
*/
  getShippingTrackingURL(webOrderId: string) {
    return (
      this._http
        .get(ApiUrlConstants.orderApiUrl + '/V1/orders/' + webOrderId + '/track')
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );
  }



  backDateOrder(WebOrderId: string): Observable<any> {
    let requestUrl = ApiUrlConstants.orderApiUrl + '/V1/back-order/' + WebOrderId
    return this._http
      .get(requestUrl)
      .map((res: Response) => res)
      .catch(this.handleErrorObservable);
  }

  /**
 * @description get Order Min Max Business Rules
 * @param {OrderRulesRequest} orderRulesRequest
 * @returns {Observable<any>}
 * @memberof OrderService
 */
  getOrderBusinessRules(orderRulesRequest: OrderRulesRequest): Observable<any> {
    let orderRulesURL = ApiUrlConstants.orderApiUrl + '/V1/order-purchase-rules?memberTitleId='
      + orderRulesRequest.memberTitleId + '&countryCode=' + orderRulesRequest.countryCode +
      '&orderType=' + orderRulesRequest.orderType;
    if (orderRulesRequest.optinFbo) {
      orderRulesURL = orderRulesURL + '&optinFbo=true';
    }
    orderRulesURL = orderRulesURL + '&orderSource=' + OrderSources.CUSTOMER;
    return this._http
      .get(orderRulesURL)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
/**
 * @description DOWNGRADE CHECK
 * @date 2019-09-06
 * @param {number} memberType
 * @param {number} memberTitleID
 * @returns {number}
 * @memberof OrderService
 */
getDowngradeTitleID(memberType: number, memberTitleID: number): number {
   if(( memberType=== MemberTypeEnum.FPC)
      || ((memberType === MemberTypeEnum.DISTRIBUTOR)
           && (memberTitleID === MemberLevel.NOVICCUSTOMER)) ){
       return  MemberLevel.PREFERREDCUSTOMER;
      } else {
        return memberTitleID;
      }
  }

  /**
   * @description get Member Order Business Rules
   * @param {*} memberId
   * @param {*} storeId
   * @returns {Observable<any>}
   * @memberof OrderService
   */
  getMemberOrderBusinessRules(memberId: number, storeId: number, isBackOrderDate: boolean, storeCountryCode: string, memberTitleId: number,
     webOrderId?: string, fromDate?: Date, toDate?: Date): Observable<any> {
    let url;
    if (webOrderId) {
      url = ApiUrlConstants.orderApiUrl + '/V1/members/' + memberId + '/order-rules?storeId=' + storeId + '&storeCountryCode=' + storeCountryCode + '&memberTitleId=' + memberTitleId + '&webOrderId=' + webOrderId;
    } else {
      url = ApiUrlConstants.orderApiUrl + '/V1/members/' + memberId + '/order-rules?storeId=' + storeId + '&storeCountryCode=' + storeCountryCode + '&memberTitleId=' + memberTitleId;
    }

    if (fromDate && toDate) {
      url = url + '&orderFromDate=' + fromDate + '&orderToDate=' + toDate;
    }

    if (isBackOrderDate) {
      const date = new Date();
      const processedMonth = date.getMonth()+1;
      const processedYear = date.getFullYear();
      url = url + '&processedMonth=' + processedMonth + '&processedYear=' + processedYear;
    }

    return this._http
      .get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
     * @description getMemberOrderRestrictionsInfo
     * @date 2020-03-18
     * @returns
     * @memberof
     */
    getMemberOrderRestrictionsInfo(userInfo: Member, countryCode: string): Observable<any> {
      if (userInfo && userInfo.memberTypeId === MemberTypeEnum.FPC) {
          userInfo.memberTitleId = MemberLevel.PREFERREDCUSTOMER;
      }
      const orderType = userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Wholesale
          : MemberOrderType.Retail;
      const memberTitleId = userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL;
      const getURL = ApiUrlConstants.orderApiUrl + '/V1/member-order-restrictions?memberTitleId='
          + memberTitleId + '&countryCode=' + countryCode + '&orderType=' + orderType;
      return this._http
          .get(getURL)
          .map((res: Response) => res.json())
          .catch(this.handleErrorObservable);
  }
  getMemberTitleId(memberInfo): number {
    if(memberInfo && memberInfo.memberTypeId){
      if((memberInfo.memberTypeId === MemberTypeEnum.FPC)
      || ((memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)
           && (memberInfo.memberTitleId === MemberLevel.NOVICCUSTOMER)) ){
       return  MemberLevel.PREFERREDCUSTOMER;
      } else {
        return memberInfo.memberTitleId;
      }
    } else {
      return memberInfo.memberTitleId;
    }
  }

  getFeaturedPacks(languageCode: string, countryCode: string, storeId: number, isTaxInclusive: boolean): Observable<any> {
    const memberTitleId = MemberLevel.PREFERREDCUSTOMER;
    const purchaseFlowType = PurchaseFlows.ENROLLMENT;
    const _productsUrl: string = ApiUrlConstants.productApiUrl + '/v1/stores/' + storeId +
      '/featured-packs?languageCode=' + languageCode + '&pageSize=10&pageNumber=1' + '&sortBy=FEATURED&memberTitleId='
      + memberTitleId + '&purchaseFlowType=' + purchaseFlowType + '&countryCode=' + countryCode
      + '&wholesaleQualified=false&optin=false&taxInclusive=' + isTaxInclusive;
    return (
      this._http
        .get(_productsUrl)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
    );
  }

  getEnrollmentkits(languageCode: string, countryCode: string, storeId: number, isTaxInclusive: boolean): Observable<any> {
    const memberTitleId = MemberLevel.PREFERREDCUSTOMER;
    const purchaseFlowType = PurchaseFlows.ENROLLMENT;
    const _productsUrl: string = ApiUrlConstants.productApiUrl + '/v1/stores/' + storeId +
      '/enrolment-kits?countryCode=' + countryCode + '&languageCode=' + languageCode +
      '&memberTitleId=' + memberTitleId + '&purchaseFlowType=' + purchaseFlowType +
      '&pageSize=20&pageNumber=1&featuredProducts=false&wholesaleQualified=false&optin=false'
      + '&taxInclusive=' + isTaxInclusive;
    return (
      this._http
        .get(_productsUrl)
        .map((res: Response) => {
          const enrollProductDetails: any = {};
          enrollProductDetails.header = res.headers;
          enrollProductDetails.body = res.json();
          return enrollProductDetails;
        })
        .catch(this.handleErrorObservable)
    );
  }


   //getting store details by storeId
   getStoreById(id: any, inactive?: boolean) {
    let getStoreURL = ApiUrlConstants.configurationApiUrl + 'store-countries/stores/' + id;
    if (inactive) {
      getStoreURL = getStoreURL + '?inactive=' + inactive;
    }
    return this._http
      .get(getStoreURL)
      .map(res => res.json())
      .catch(this.handleErrorObservable);
  }
    /**
   * create order
   * @param  {Order} paymentRequest
   * @returns Observable
   */
  getOrderDetailsUuid(uuid:string,distrubutorId?:string): Observable<any> {
    if(distrubutorId){
      return this._http
      .get(ApiUrlConstants.orderApiUrl + '/V1/order?uuid=' + uuid + '&distrubutorId=' + distrubutorId)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
    }
    else{
      return this._http
      .get(ApiUrlConstants.orderApiUrl + '/V1/order?uuid=' + uuid)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
    }

  }

  isValidDate(startDate, endDate) {
    const fromDateFormat = 'DD-MM-YYYY';
    const toDateFormat = 'YYYY-MM-DD';
    const orderedDate = moment().format(toDateFormat);
    let isValid = false;
    if (startDate) {
        const start = startDate ? moment(startDate, fromDateFormat).format(toDateFormat) : null;
        const end = endDate ? moment(endDate, fromDateFormat).format(toDateFormat) : null;
        if (start) {
            if (end) {
                isValid = moment(orderedDate).isBetween(start, end, null, '[]');
            } else {
                isValid = moment(orderedDate).isSameOrAfter(start);
            }
        }
    }
    return isValid;
}

  /** gets bonus bank details for schema form */

  getBonusBankDetails(optionsUrl: string): Observable<any> {
    const paymentHeaders = this.getPaymentHeaders();
    return this._http
      .get(optionsUrl, { headers: paymentHeaders })
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  download(distributorId: any, systemOrderNumber: any): Observable<Blob> {
    let getURL = ApiUrlConstants.orderApiUrl + '/v1' + '/download/' + distributorId + '/' + systemOrderNumber;
    const options = new RequestOptions({ responseType: ResponseContentType.Blob });
      return this._http.get(getURL,options)
        .map(res => res.blob())
        .catch(this.handleErrorObservable);
}

downloadOrderInvoice(distributorId: any, systemOrderNumber: any, country: any): Observable<Blob> {
  let getURL = ApiUrlConstants.orderApiUrl + '/v1' + '/downloadOrderInvoice/' + distributorId + '/' + systemOrderNumber + '/' + country;
  const options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this._http.get(getURL,options)
      .map(res => res.blob())
      .catch(this.handleErrorObservable);
}

  getChangeReasons(elements?: string, operatingCountryId?: number, isDesc?: boolean, pageNumber?: number, pageSize?: number, reasonNote?: string, operatingCountryCode?: string) {
    let apiUrl = ApiUrlConstants.orderApiUrl + '/v1' + '/order-status-change-reason';
    if (isDesc != null && isDesc != undefined) { apiUrl = apiUrl + '?sort=' + (isDesc ? 'ASC' : 'DESC'); }
    if (pageSize) { apiUrl = apiUrl + '&pageSize=' + pageSize; }
    if (pageNumber) { apiUrl = apiUrl + '&pageNumber=' + pageNumber; }
    if (elements) { apiUrl = apiUrl + '&elements=' + elements; }
    if (reasonNote) { apiUrl = apiUrl + '&reasonNote=' + reasonNote; }
    if (operatingCountryId && operatingCountryId != 0) { apiUrl = apiUrl + '&operatingCountryId=' + operatingCountryId; }
    if (operatingCountryCode) { apiUrl = apiUrl + '&operatingCountryCode=' + operatingCountryCode; }
  return this._http
    .get(decodeURIComponent(encodeURIComponent(apiUrl)))
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
}

  /*
 To get Reasons Based on Id
 */
getReason(id: number) {
  return this._http
    .get(decodeURIComponent(encodeURIComponent(ApiUrlConstants.orderApiUrl + '/v1/'+ 'order-status-change-reason/' + id)))
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
}

  /*
  To Create And Update Reason
  */
 createAndUpdateReasons(reasonData: any) {
  const createAndUpdateReasonUrl = ApiUrlConstants.orderApiUrl + '/v1/'+ 'order-status-change-reason';
  return this._http
    .post(createAndUpdateReasonUrl, (reasonData))
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
}

/*
 * get refund amount
 * @param  webOrderID
 */
getRefundAmount(webOrderID: string) {
  const headers = this.getPaymentHeaders();
  let url = ApiUrlConstants.paymentApiUrl + 'payments/orders/' + webOrderID;
  return this._http
    .get(url, { headers: headers })
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
  }


  updateDistributorIdForExistingOrder(orderId:number,webOrderId:string,distributorId:String,updatedBy:number,operatingCountryCode:String):Observable<any>{
    let url = ApiUrlConstants.orderApiUrl+'/v1/update-order-distrbutorId/'+orderId+'?webOrderId='+webOrderId+'&updatedBy='+updatedBy+'&distributorId='+distributorId+'&operatingCountryCode='+operatingCountryCode;
    return this._http
    .put(url,null)
    .map((res:Response)=>res.json())
    .catch(this.handleErrorObservable);
  }

  updateProcessingPeriodForOrder(webOrderId: string, company: string, year: number, month: number, updatedBy:number, orderID:number) {
    let url = ApiUrlConstants.orderApiUrl + '/v1/update-order-processing-period/webOrderId/' + webOrderId + '?company=' + company + '&newProcessingYear=' + year + '&newProcessingMonth=' + month +'&updatedBy='+updatedBy +'&orderId='+orderID;
    return this._http
      .put(url, null).pipe(map((res: any) => res.json()),
        catchError(this.handleErrorObservable));
  }

  public getIntegratedTerminals(storeId, paymentMethodId) : Observable<any> {
    let headers = this.getPaymentHeaders();
    const url = ApiUrlConstants.paymentApiUrl + "/stores/" + storeId + "/paymentMethod/" + paymentMethodId + "/adyen-terminals"
    return this._http
      .get(url, { headers: headers })
      .map((res:Response)=>res.json())
      .catch(this.handleErrorObservable)
   }

   public cancelTerminalPayment(body) : Observable<any> {
    let headers = this.getPaymentHeaders();
    const url = ApiUrlConstants.paymentApiUrl + "/payments/terminal/cancel-payment";
    return this._http
      .post(url, JSON.stringify(body), { headers: headers })
      .map((res:Response)=>res.json())
      .catch(this.handleErrorObservable)
   }

   getTerminalPaymentStatus(body): Observable<any> {
    const headers = this.getPaymentHeaders();
    const url = ApiUrlConstants.paymentApiUrl + "/payments/terminal/payment-status";
    return this._http
    .post(url, body, { headers: headers })
    .map((res:Response) => res.json())
    .catch(this.handleErrorObservable);
}

  getAutoShipDetailsByMemberId(memberId: any): Observable<any> {
    const autoShipUrl = ApiUrlConstants.orderApiUrl + '/v1/autoships/member/' + memberId;
    return this._http
      .get(autoShipUrl)
      .map((res: Response) => res.json())
      .pipe(catchError(this.handleErrorObservable));
  }

  updateAutoshipProfile(memberId: number, MemberType: number, taxInclusive: boolean ,optIn: boolean): Observable<any> {
    let url = ApiUrlConstants.orderApiUrl + '/v1/autoship-upgrade/member/' + memberId + 
    '?optin=' +optIn+ '&taxInclusive=' +taxInclusive+ '&memberType=' + MemberType;
    return this._http
      .put(url, null).pipe(map((res: any) => res.json()),
        catchError(this.handleErrorObservable));
  }
}





// WEBPACK FOOTER //
// ./src/app/customerservice/services/order.service.ts